export const createNote = async (state, newNote) => {
  const { crudActions } = state

  const note = {
    body: newNote.body,
    visibility: newNote.visibility,
    note_template_id: newNote.noteTemplate?.id
  }
  await crudActions.create({ note })
}

export const updateNote = async (state, newNote) => {
  const { crudActions } = state
  const updatedNote = {...state.notes[state.noteIndex], ...newNote}

  await crudActions.update(updatedNote)
}

export const toggleNoteVisibility = async (state, noteIndex) => {
  const { crudActions, notes } = state
  const note = notes[noteIndex]
  const updatedNote = { ...note, visibility: !note.visibility }

  await crudActions.update(updatedNote)
}

export const deleteNote = async (state) => {
  const { crudActions } = state

  const noteId = state.notes[state.noteIndex].id


  await crudActions.delete(noteId)
}

// helpers

export const buildNote = (note) => {
  return {
    id: note?.id ?? null,
    body: note?.body ?? null,
    visibility: note?.visibility ?? 0, // public
    noteTemplate: note?.noteTemplate ?? null,
  }
}